import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chevron-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-0eff3585"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "top_option" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", { offset: _ctx.m_show }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.Show()), ["prevent"])),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Show(false))),
      style: _normalizeStyle({ width: _ctx.MaxWidth + 'ch' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.Selected), 1),
        _hoisted_3
      ]),
      (_ctx.Available.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["dropdown-content", { show_menu: _ctx.m_show }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Available, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s,
                onClick: ($event: any) => (_ctx.Toggle(s)),
                class: "entry"
              }, [
                _createElementVNode("h2", null, _toDisplayString(s), 1)
              ], 8, _hoisted_4))
            }), 128))
          ], 2))
        : _createCommentVNode("", true)
    ], 38)
  ]))
}